import { gql } from '@apollo/client';
export const GET_URL = gql `
  query GET_URL($input: GetUrlInput!) {
    getUrl(input: $input)
  }
`;
export const UPLOAD_PARAMS = gql `
  mutation UPLOAD_PARAMS($input: UploadInput!) {
    uploadParams(input: $input)
  }
`;
export const LOG_UPLOAD_FAILURE = gql `
  mutation LOG_UPLOAD_FAILURE($input: UploadFailureInput!) {
    logUploadFailure(input: $input)
  }
`;
